module.exports = __webpack_public_path__ + "img/3-4.fed669c0.jpg";